<template>
  <div class="footer" :style="{'background':landingPage.themeColor,'color':landingPage.negativeColor}">
    <div class="_730">
      <a href="#" class="footer-logo-wrap w-inline-block">
        <img :src="value.backgroundImage.imageURL|| landingPage.logo.imageURL" loading="lazy" alt />
      </a>
      <div class="social-media">
        <a v-if="landingPage.facebook" :href="landingPage.facebook" target="_blank">
          <img width="24" src="../assets/images/social-media/facebook.svg" />
        </a>
        <a v-if="landingPage.twitter" :href="landingPage.twitter" target="_blank">
          <img width="24" src="../assets/images/social-media/twitter.svg" />
        </a>
        <a v-if="landingPage.linkedIn" :href="landingPage.linkedIn" target="_blank">
          <img width="24" src="../assets/images/social-media/linkedin.svg" />
        </a>
        <a v-if="landingPage.instagram" :href="landingPage.instagram" target="_blank">
          <img width="24" src="../assets/images/social-media/instagram.svg" />
        </a>
        <a v-if="landingPage.vimeo" :href="landingPage.vimeo" target="_blank">
          <img width="24" src="../assets/images/social-media/vimeo.svg" />
        </a>
      </div>
      <div class="footer-info" v-html="value.description" :style="{'color':landingPage.negativeColor}"></div>
    </div>
  </div>
</template>
    
<script>
export default {
  name: "Footer-Stripe",
  props: {
    value: Object,
    landingPage: Object,
  },
};
</script>

<style scoped>
.social-media{
    margin-top: 10px;
}
.social-media a{
    margin-left: 10px;
    margin-right: 10px;
}
</style>